import React from 'react'
import * as S from './AboutMe.styles'
import LogoGitHub from '../../png-extras/github2.png'
import LogoLinkedin from '../../styles/svg/linkedin.svg'
import LogoUdemy from '../../styles/svg/udemy.png'
import LogoInstagram from '../../styles/svg/instagram.svg'

const AboutMe = () => {
    const socialNetworks = [
        {
            name: "GitHub",
            link: "https://github.com/facuadaro",
            logo: LogoGitHub
        },
        {
            name: "Linkedin",
            link: "https://www.linkedin.com/in/facundo-adaro-0b7168223",
            logo: LogoLinkedin
        },
        {
            name: "Udemy",
            link: "https://www.udemy.com/user/facundo-adrian-adaro/",
            logo: LogoUdemy
        },
        {
            name: "Instagram",
            link: "https://www.instagram.com/facuu.adaro/",
            logo: LogoInstagram
        }


    ]

    return (
        <>
            <S.ContainerAboutMe id='about-me'>
                <S.ContainerText>
                    <S.Title>
                        <p>👋🏼Hello, i am</p>
                        <p>Facundo Adaro</p>
                        <p>Frontend Developer</p>
                    </S.Title>
                    <S.DescriptionText>
                        <p>Welcome to my website! I'm a 24 years old frontend web developer who is passionate about technology. My focus is on creating visually appealing and highly intuitive websites. I stay up to date with the latest trends and technological advancements. Here, you can explore examples of my work and learn more about my journey in web development.</p>
                    </S.DescriptionText>
                    <S.ContainerIcons>
                        {socialNetworks.map((network, index) => (
                            <a key={index} href={network.link} target='_blank' rel='noreferrer'>
                                <img src={network.logo} alt={network.name} />
                            </a>
                        ))}
                    </S.ContainerIcons>
                </S.ContainerText>
                <S.ContainerImage>
                    <img src="/img/FotoCV-editada.jpg" alt="Facu Adaro - Frontend Developer" />
                </S.ContainerImage>

            </S.ContainerAboutMe>
            <S.ExtraDates>
                <p>Almafuerte, Córdoba, Argentina.</p>
            </S.ExtraDates>
        </>
    )
}

export default AboutMe